"use strict";

exports.__esModule = true;
exports.PastCycle = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Time = require("../../Time");
var _PlantStateActivities = require("../../PlantStateActivities");
var _CycleListStyling = require("./CycleListStyling");
var _FormattedDuration = _interopRequireDefault(require("../../Widgets/FormattedDuration"));
var _Utils = require("./Utils");
var _excluded = ["isCurrent", "isSelected", "classification", "plantStateActivities", "now", "time", "onClick"];
var _dec, _class, _PastCycle;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * An item in a cycle list.
 */
var PastCycle = exports.PastCycle = (_dec = _Time.TimeContext.withContext, _dec(_class = (_PastCycle = /*#__PURE__*/function (_React$PureComponent) {
  function PastCycle() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.handleClick = function (event) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        classification = _this$props.classification;
      if (typeof onClick === "function") {
        onClick(classification, event);
      }
    };
    return _this;
  }
  _inheritsLoose(PastCycle, _React$PureComponent);
  var _proto = PastCycle.prototype;
  _proto.abbreviateStateName = function abbreviateStateName(state) {
    if (state.id === "downtime.unplanned") {
      return "UDT";
    }
    if (state.id === "downtime.planned") {
      return "PDT";
    }
    return state.name;
  };
  _proto.render = function render() {
    var _classification$value;
    var _this$props2 = this.props,
      isCurrent = _this$props2.isCurrent,
      isSelected = _this$props2.isSelected,
      classification = _this$props2.classification,
      plantStateActivities = _this$props2.plantStateActivities,
      _this$props2$now = _this$props2.now,
      now = _this$props2$now === void 0 ? new Date() : _this$props2$now,
      time = _this$props2.time,
      onClick = _this$props2.onClick,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var state = (0, _PlantStateActivities.getPlantState)(plantStateActivities.states, classification.value.state);
    var activity = classification.value.activity ? (0, _PlantStateActivities.getPlantActivity)(plantStateActivities.activities, classification.value.activity) : undefined;
    var duration = Math.round(((isCurrent ? Math.max(now.valueOf(), classification.interval.endMillis) : classification.interval.endMillis) - classification.interval.startMillis) / 1000);
    var durationFormat = duration > 60 * 5 ? "{hours} {minutes}" : "{minutes} {seconds}";
    var listItemHeaderText = activity ? this.abbreviateStateName(state) + " - " + activity.name : state.name;
    return /*#__PURE__*/_react["default"].createElement(_CycleListStyling.CycleListItemButton, _extends({
      "aria-selected": isSelected
    }, extra, {
      "data-testid": "CycleListItemButton-" + classification.interval.startMillis + "-" + classification.interval.endMillis,
      onClick: this.handleClick,
      type: "button"
    }), /*#__PURE__*/_react["default"].createElement(_CycleListStyling.CycleListItemColor, {
      state: state
    }, (0, _Utils.isUserInputClassification)((_classification$value = classification.value) == null ? void 0 : _classification$value.classification_source) && /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_CycleListStyling.CycleListItemBody, null, /*#__PURE__*/_react["default"].createElement(_CycleListStyling.CycleListItemButtonHeader, {
      ellipsize: true
    }, listItemHeaderText), /*#__PURE__*/_react["default"].createElement(_CycleListStyling.CycleListItemButtonBody, null, /*#__PURE__*/_react["default"].createElement(_CycleListStyling.TimeWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedTime, {
      value: classification.interval.startMillis,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: time ? time.timezone.name : ""
    }), "\u2013", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedTime, {
      value: classification.interval.endMillis,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: time.timezone.name
    })), /*#__PURE__*/_react["default"].createElement(_CycleListStyling.DurationWrapper, null, /*#__PURE__*/_react["default"].createElement(_FormattedDuration["default"], {
      format: durationFormat,
      seconds: duration,
      textComponent: _CycleListStyling.MutedText
    })))));
  };
  return PastCycle;
}(_react["default"].PureComponent), _PastCycle.defaultProps = {
  time: undefined
}, _PastCycle)) || _class);